export default __webpack_public_path__ + "src/_images/ReportCard_Icon.svg";